// extracted by mini-css-extract-plugin
module.exports = {"indButton":"INDButton_indButton___spG7"};